import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../../../incase-domain/components/modals/directory/Modal';
import Label from '../../../../incase-domain/components/label/Label';
import InputWithCharacterCounter from '../../../../components/slides/highlighted/common/InputWithCharacterCounter';

const FOLDER_NAME_MAX_LENGTH = 100;
const FOLDER_FORM_ID = 'presentation_folder_form';

export function FolderNameModal({
    open,
    title,
    initialName,
    confirmText,
    saving,
    onClose,
    onSubmit,
}: {
    open: boolean;
    title: string;
    initialName?: string;
    confirmText: string;
    saving: boolean;
    onClose: () => void;
    onSubmit: (name: string) => void;
}): JSX.Element {
    const {t} = useTranslation();
    const [name, setName] = useState(initialName ?? '');
    const [error, setError] = useState('');

    useEffect(() => {
        if (open) {
            setName(initialName ?? '');
            setError('');
        }
    }, [open, initialName]);

    const handleSubmit = (event: React.FormEvent): void => {
        event.preventDefault();
        const trimmed = name.trim().replace(/\s+/g, ' ');
        if (!trimmed) {
            setError(t('editorPage.folders.nameRequired'));
            return;
        }
        onSubmit(trimmed);
    };

    return (
        <Modal
            isOpen={open}
            header={title}
            icon="solar:folder-linear"
            showConfirm
            confirmText={confirmText}
            formId={FOLDER_FORM_ID}
            confirmDisabled={saving}
            onCancel={onClose}
            dataCy="folder-name-modal"
        >
            <form id={FOLDER_FORM_ID} onSubmit={handleSubmit} noValidate>
                <Label>{t('editorPage.folders.folderName')}</Label>
                <InputWithCharacterCounter
                    value={name}
                    onChange={(value) => {
                        setName(value);
                        if (error) setError('');
                    }}
                    maxLength={FOLDER_NAME_MAX_LENGTH}
                    placeholder={t('editorPage.folders.folderNamePlaceholder')}
                    dataCy="folder-name-input"
                />
                {error && <div className="is-error">{error}</div>}
            </form>
        </Modal>
    );
}
